// https://vuex.vuejs.org/en/getters.html

export default {
  fitting_types(state) {
    return state.fitting_types;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
